import { Button, Card, Col, Row, Table, message, Input, DatePicker } from 'antd';
import moment from 'moment';
import React, { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, withRouter,useLocation } from 'react-router-dom';
import { fetchAllKecamatan, fetchAllKecamatanQuery } from 'redux/features/kecamatan';

const selectStyle = {
    width: "100%",
    backgroundColor: "white"
};

export const KABUPATEN = () => {

    const location = useLocation()
    const history = useHistory()
    const dispatch = useDispatch();
    const [kecamatan,setKecamatan] = useState([])

    const getData = async (kabupaten) => {
        try {
            const kecamatan = await dispatch(fetchAllKecamatanQuery({
                kabupaten: kabupaten,
                limit: 30,
                page: 0
            })).unwrap()
            setKecamatan(kecamatan)
        } catch (error) {
            message.error(error?.message || 'Failed to fetch data')
        }
    }

    useEffect(() => {
        const itemId = location.state?.kabupaten
        if (itemId) {
            getData(itemId)
        }
    }, [])

    const tableColumns = [
        {
            title: 'ID',
            dataIndex: '_id',
            key: '_id',
        },
        {
            title: 'Nama',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Kelurahan',
            dataIndex: 'kelurahan',
            render: (_, record) => {
                return (
                    <div onClick={() => {
                        history.push("/app/kelurahan", {
                            id_kecamatan: record.id_kecamatan
                        })
                    }}><a>Lihat Kelurahan</a></div>
                )
            },
        },
        {
            title: 'Edit',
            dataIndex: 'edit',
            render: (_, record) => {
                return (
                    <a onClick={() => {
                        history.push("/app/detail-kecamatan", {
                            status: "DETAIL",
                            id_kabupaten:location.state?.id_kabupaten,
                            id_kecamatan: record.id_kecamatan
                        })
                    }}>Edit</a>
                )
            },
        }
    ];

    const onSearch = (value) => console.log(value);

    return (
        <>
            <Row gutter={24}>
                <Col xs={24} sm={24} md={24} lg={24}>
                    <h2>Total {kecamatan.length} Kecamatan </h2>
                    <p>Semua data yang telah masuk dan dibutuhkan tindakan lanjut</p>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col xs={24} sm={24} md={24} lg={24}>
                    <Card>
                        <Table
                            className="no-border-last"
                            columns={tableColumns}
                            dataSource={kecamatan}
                            rowKey='id'
                            Row={5}
                            pagination={true}
                        />
                    </Card>
                </Col>
            </Row>
            <Row gutter={24}>
                <Col xs={24} sm={24} md={24} lg={24}>
                    <Button type="primary" style={{ border: "0px" }} htmlType="submit" onClick={() => {
                        history.push({
                            status: "ADD",
                            id_kabupaten:location.state?.id_kabupaten,
                            pathname: '/app/detail-kecamatan'
                        })
                    }} block>
                        Tambah Data Kecamatan
                    </Button>
                </Col>
            </Row>
        </>
    )
}


export default withRouter(KABUPATEN);
